<template src="./html/Datatable.html"></template>

<script>
	import Vuetable from 'vuetable-2/src/components/Vuetable'
	import VuetablePaginationInfo from 'vuetable-2/src/components/VuetablePaginationInfo'
	import VuetablePagination from 'vuetable-2/src/components/VuetablePagination'
	import FilterBar from './FilterBar'
	import UsersMap from './UsersMap'
	import VueElementLoading from 'vue-element-loading'

	export default {
		props: ['isAuth', 'user'],
		components: {
			'datatable': Vuetable,
			'pagination-info': VuetablePaginationInfo,
			'pagination': VuetablePagination,
			'filter-bar': FilterBar,
			'users-map': UsersMap,
			'loading': VueElementLoading,
		},
		data () {
			return {
				perPages: [
					{
						label: 20,
						value: 20,
					},
					{
						label: 50,
						value: 50,
					},
					{
						label: 100,
						value: 100,
					},
					{
						label: 'Todo',
						value: null,
					},
				],
				datatable: {
					api: this.$env.ROOT + '/api/' + this.$lang.getLang() + '/admin/users/datatable',
					loading: true,
					moreParams: {
						filter: {
							text: null,
							unavalible: false,
						},
					},
					page: 20,
					path: '',
					sortOrder: [
						{
							field: 'created_at',
							sortField: 'created_at',
							direction: 'desc',
						}
					],
					options: {
						headers: {
							'Authorization': 'Bearer ' + this.$auth.getToken()
						}
					},
					css: {
						table: {
							sortableIcon: 'fa fa-sort',
							tableClass: 'table table-hover table-striped table-condensed',
							ascendingIcon: 'fa fa-caret-up',
							descendingIcon: 'fa fa-caret-down',
						},
						pagination: {
							wrapperClass: "pagination pull-right",
							activeClass: "btn-default disabled",
							disabledClass: "disabled",
							pageClass: "btn btn-default",
							linkClass: "btn btn-default",
							icons: {
								first: "fa fa-fast-backward",
								prev: "fa fa-step-backward",
								next: "fa fa-step-forward",
								last: "fa fa-fast-forward",
							}
						},
					},
					fields: [
						{
							name: 'id',
							title: this.$platform.setting.number_symbol,
							sortField: 'id',
						},
						{
							name: '__slot:staff_name',
							title: 'Nombre',
							sortField: 'staff.first_name',
						},
						{
							name: '__slot:staff_departments',
							title: 'Departamentos',
						},
						{
							name: 'email',
							title: 'E-mail',
							sortField: 'email',
						},
						{
							name: 'staff.skills',
							title: 'Habilidades',
							sortField: 'staff.skills',
						},
						{
							name: '__slot:staff_available',
							title: 'Disponibilidad',
							sortField: 'staff.available',
						},
						{
							name: '__slot:staff_author',
							title: 'Autor',
						},
						{
							name: 'created_at',
							title: 'Fecha',
							sortField: 'created_at',
							callback: function(value) {
								return moment(value).format('DD/MM/YY H:mm')
							},
						},
						{
							name: '__slot:staff_actions',
							title: '',
						},
					],
				},
				users: null,
			}
		},
		created() {
			this.init()
		},
		methods: {
			init() {
				this.getUsers()
			},
			getUsers() {
				this.$http.get('admin/users')
				.then(response => {
					this.users = response.body
				})
			},
			reload() {
				this.$nextTick( () => this.$refs.datatable.refresh())
			},
			loading() {
				this.datatable.loading = true
			},
			loaded() {
				this.datatable.loading = false
			},
			onPaginationData (paginationData) {
				this.$refs.paginationInfo.setPaginationData(paginationData)
				this.$refs.pagination.setPaginationData(paginationData)
			},
			onChangePage (page) {
				this.$refs.datatable.changePage(page)
			},
			filterSet() {
				this.$nextTick( () => this.$refs.datatable.refresh())
			},
			filterReset() {
				this.clearFilter()
				this.$nextTick( () => this.$refs.datatable.refresh())
			},
			clearFilter() {
				this.datatable.moreParams.filter.text = null
				this.datatable.moreParams.filter.unavalible = false
			},
		},
	}
</script>



// WEBPACK FOOTER //
// src/components/users/views/Datatable.vue